import { render, staticRenderFns } from "./auth-admin-as-user.vue?vue&type=template&id=321f7f08&"
import script from "./auth-admin-as-user.vue?vue&type=script&lang=ts&"
export * from "./auth-admin-as-user.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports